/**
 * @generated SignedSource<<c07a7f4a94a4d0f5448dbed3edc82014>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BlogSubcategoryLanding_Query$data = {
  readonly blogPosts: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"BlogPostItem_BlogPost">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly blogSubcategory: {
    readonly blogCategory: {
      readonly name: string | null | undefined;
      readonly slug: string | null | undefined;
    } | null | undefined;
    readonly description: string | null | undefined;
    readonly heroImageUrl: string | null | undefined;
    readonly name: string | null | undefined;
    readonly slug: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "BlogSubcategoryLanding_Query";
};
export type BlogSubcategoryLanding_Query$key = {
  readonly " $data"?: BlogSubcategoryLanding_Query$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogSubcategoryLanding_Query">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "subcategory"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogSubcategoryLanding_Query",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "last",
          "value": 20
        },
        {
          "kind": "Variable",
          "name": "subcategorySlug",
          "variableName": "subcategory"
        }
      ],
      "concreteType": "BlogPostConnection",
      "kind": "LinkedField",
      "name": "blogPosts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "BlogPost",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "BlogPostItem_BlogPost"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "slug",
          "variableName": "subcategory"
        }
      ],
      "concreteType": "BlogSubcategory",
      "kind": "LinkedField",
      "name": "blogSubcategory",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "heroImageUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "BlogCategory",
          "kind": "LinkedField",
          "name": "blogCategory",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "8252a805b1510c15455af626fcda1783";

export default node;
